import React, { useEffect, useState } from 'react'
import { InputRange as Range } from '@welbe/web-design-system'
import { Label } from 'Views/survey/forms/Builder/components/Label/Label'

import { Container, ContainerRange } from './InputRange.styles'

interface InputRangeContainerProps {
	id: string
	text: string
	initialValue?: any
	options?: any
	questionAnswerId?: any
	onChange: any
	isVisible?: boolean
}

type inputRange = '0' | '25' | '50' | '75' | '100'

const formatter = {
	0: 'Nunca',
	25: 'Casi nunca',
	50: 'Algunas veces',
	75: 'Casi siempre',
	100: 'Siempre',
}

export const InputRange = ({
	id,
	text,
	options,
	questionAnswerId,
	isVisible,
}: InputRangeContainerProps): JSX.Element => {
	const [inputRangeValue, setInputRangeValue] = useState<inputRange>('50')
	const [intialValue, setInitialValue] = useState<any>()

	const formatterToValue = {
		[options.find((option: any) => option.description === 'Nunca')?.id]: '0',
		[options.find((option: any) => option.description === 'Casi nunca')?.id]:
			'25',
		[options.find((option: any) => option.description === 'Algunas veces')?.id]:
			'50',
		[options.find((option: any) => option.description === 'Casi siempre')?.id]:
			'75',
		[options.find((option: any) => option.description === 'Siempre')?.id]:
			'100',
	}

	useEffect(() => {
		if (questionAnswerId) {
			const formattedValue = formatterToValue[questionAnswerId]
			setInitialValue(formattedValue)

			if (
				formattedValue === '0' ||
				formattedValue === '25' ||
				formattedValue === '50' ||
				formattedValue === '75' ||
				formattedValue === '100'
			) {
				setInputRangeValue(formattedValue)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [questionAnswerId, options])

	if (!isVisible) {
		return <input id={id} value="empty" style={{ display: 'none' }} />
	}

	const handleChange = (value: string) => {
		if (
			value === '0' ||
			value === '25' ||
			value === '50' ||
			value === '75' ||
			value === '100'
		) {
			setInputRangeValue(value)
		}
	}

	return (
		<Container>
			<input
				id={id}
				value={
					options.find(
						(option: any) => option.description === formatter[inputRangeValue],
					)?.id
				}
				style={{ display: 'none' }}
			/>
			<Label>{text}</Label>
			<ContainerRange>
				<Range
					min="0"
					max="100"
					step="25"
					initialDefaultValue={intialValue}
					hasSlider={true}
					formatterValues={formatter}
					value={inputRangeValue}
					hasMarkers={true}
					id={`index-${id}`}
					onChange={handleChange}
				/>
			</ContainerRange>
		</Container>
	)
}
